import { createContext } from 'react';

import { OSPatchInstall } from '@totem/components/devices/os-patch-installs/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: OSPatchInstall[];
  action: string;
  actionItem: OSPatchInstall;
  onAction?: (action: string, item: OSPatchInstall) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
